export const applyTwitterDecoration = (target) => {
  window.twttr.ready((twttr) => {
    twttr.widgets.load(target)
  })
}
